import React from "react";
import { Link, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { browserHistory } from 'react-router';
import * as dashboardActions from "../../actions/dashboardActions";
// import * as app from '../../scripts/app';
// import * as authorize from '../authorization/roleTypes';
import * as SVGICONS from '../../images/img/images';
import RoleAwareComponent from '../authorization/roleaware';
import * as constant from '../../constants/constant.js';
import * as url from '../../tools/config';
import openSocket from 'socket.io-client';
import $ from 'jquery';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment';

// import Moment from '../../../node_modules/react-moment';
import SpecialistProfile from '../specialist/specialistProfile';
import Specialistdocument from '../specialist/specialistDocument';
import specialistUploadDocument from '../specialist/specialistUploadDocument';
import specialistEvents from '../specialist/specialistEvents';
import eventDetails from '../sitemanagement/eventDetails';
import specialistappointment from '../specialist/specialistappointment.';
import specialistAddEditAssistant from '../specialist/specialistAddEditAssistant';
import specialistAssistant from '../specialist/specialistAssistant';
import feedbackListing from '../specialist/feedbackListing';
import appointmentConsultation from '../specialist/pages/appointmentConsultation';
import notifications from '../common/notifications';
import specialistSettings from '../specialist/pages/specialistSettings';
import specialistAccounts from '../specialist/pages/specialistAccounts';
import specialistSecurity from '../specialist/pages/specialistSecurity';
import specialistPayment from '../specialist/pages/specialistPayment';
import specialistPrescription from '../specialist/pages/specialistPrescription';
import specialistCalendar from '../specialist/pages/specialistCalendar';
import specialistSecretary from '../specialist/pages/specialistSecretary';
import specialistBlog from '../specialist/specialistBlog';
import specialistBlogList from '../specialist/specialistBlogList';
import specialistPatients from '../specialist/specialistPatients';
import callWaiting from '../videocall/components/callWaiting';
import videoCallConnect from '../videocall/components/videoCallConnect';
import videoCallReceive from '../videocall/components/videoCallReceive';
import watingRoomReceiver from '../videocall/components/watingRoomReceiver';
import specialistStatistics from '../specialist/specialistStatistics';
import specialistAppointmentHistory from '../specialist/specialistAppointmentHistory';
import blogDetails from '../specialist/blogDetails';
import feedbackResponse from '../specialist/feedbackResponse';
import verifySpecialist from '../specialist/verifySpecialist';
import specialistSupport from '../specialist/specialistSupport';
import SpecialistPopup from '../admin/dashboard/popupSpecialist';
import NewDocument from "./../specialist/NewDocument";
import upgrade from '../specialist/pages/upgrade';

let environment = process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_NODE_ENV : 'development'
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
const CHECK_INTERVAL = 15000 // in ms

//landing page presentational component
class Dashboard extends RoleAwareComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			modalIsOpen: false,
			profileId: '',
			appointments: 0,
			user: {},
			modalSpecialist: false,
		};
		this._logout = this._logout.bind(this);
		this.handleBreadCrumbsDashboard = this.handleBreadCrumbsDashboard.bind(
			this
		);
		this.handleProfile = this.handleProfile.bind(this);
		this.toggle = this.toggle.bind(this);
		if (localStorage.getItem('userType') == 'specialist') {
			this.initInterval();
		}
	}
	toggle(e, menuClicked) {
		var windowWidth = $(window).width();
		if (windowWidth <= 768) {
			if (e == true) {
				$('body').toggleClass('sidebar-open');
			} else {
				$('body').toggleClass('sidebar-open');
			}
		}
		if (windowWidth >= 768) {
			if (e == true) {
				$('body').toggleClass('sidebar-collapse');
			} else if (e == false) {
				$('body').toggleClass('sidebar-collapse');
			}
		}
	}
	openModal() {
		this.setState({ modalIsOpen: true });
	}

	afterOpenModal() {
		// references are now sync'd and can be accessed.
		this.subtitle.style.color = '#f00';
	}

	closeModal() {
		this.setState({ modalIsOpen: false });
	}
	componentDidMount() {
		const user = JSON.parse(localStorage.getItem('user'));
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let settingsObj = {
			token: userToken,
			specialistId: specialistId,
			userlocation: moment.tz.guess(),
			todayDate: new Date(moment().startOf('day')),
			todayDateEnd: new Date(moment().endOf('day')),
		};
		this.props.actions.getAppointmentsCount(settingsObj);
		let loginFirst = localStorage.getItem('isLoginFirst');
		console.log('loginFirst:', loginFirst);
		if (!loginFirst) {
			localStorage.setItem('isLoginFirst', 'false');
			this.setState({ modalSpecialist: true });
		}
		if (user.isVerified == 1) {
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui disclaimer_appointement'>
							<a
								style={{ cursor: 'pointer' }}
								className='closeBtn'
								onClick={onClose}></a>

							<h1>Notice</h1>
							{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
							<span>
								{`You must upload verification documents for your vetting to be
								successful. Please complete your profile on this page and then
								navigate to the ‘My Documents’ page to upload the required
								documents for verification. Once you have been vetted you will
								be able to consult patients across the globe. ${this.state.modalSpecialist}, ${loginFirst}`}
							</span>
							<div className='bottomBtn text-center'>
								<button
									type='button'
									onClick={onClose}
									className='btn btn-warning btn-lg'>
									Ok
								</button>
							</div>
						</div>
					);
				},
			});
		}
	}

	initInterval() {
		setInterval(() => {
			if (localStorage.getItem('userType') == 'specialist') {
				let userToken = localStorage.getItem('token');
				let specialistId = localStorage.getItem('userId');

				let settingsObj = {
					token: userToken,
					specialistId: specialistId,
					userlocation: moment.tz.guess(),
					todayDate: new Date(moment().startOf('day')),
					todayDateEnd: new Date(moment().endOf('day')),
				};
				this.props.actions.getAppointmentsCount(settingsObj);
			}
		}, CHECK_INTERVAL);
	}
	handleProfile() {}
	componentWillMount() {
		// let userToken = localStorage.getItem('token');
		// let specialistId = localStorage.getItem('userId');
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			appointments: nextProps.appointments ? nextProps.appointments : 0,
		});
	}

	_logout(event) {
		let userId = localStorage.getItem('userId');
		this.props.actions.logout({ userId: userId });
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}

	handleBreadCrumbsDashboard(data) {
		this.setState({ breadCrumb: data });
	}
	isClicked() {
		localStorage.setItem('isClicked', 'true');
  }
  handleSubmit(e) {
    // e.preventDefault();
    console.log('bb');
    this.setState({ modalSpecialist: !this.state.modalSpecialist })
  };
	render() {
		var defaultImagePath =
			constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user')
			? JSON.parse(localStorage.getItem('user'))
			: {};
		var windowWidth = $(window).width();

		var condition2 = windowWidth >= 768;
		let imagePath = '';
		if (user.image == constant.DEFAULT_USER_IMAGE) {
			imagePath =
				constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			imagePath =
				constant.PRODUCTION_IMAGE_URL +
				constant.UPLOAD_FOLDER +
				localStorage.getItem('userId') +
				'/' +
				user.image;
		}

		// var children = React.Children.map(this.props.children, function (child) {
		//     return child

		// }.bind(this));
		if (user == {}) {
			this.props.history.push('/');
		}
		// user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition =
			(user.userName != undefined || user.gender != undefined) &&
			user.availabilityCount > 0 &&
			user.isVerified == '2';

		var TodayDate = new Date();
		var appointmentsCount = [];
		for (var i = 0; i < this.state.appointments.length; i++) {
			//
		}
		for (var j = 0; j < this.state.appointments.length; j++) {
			if (
				moment
					.parseZone(TodayDate)
					.isSame(this.state.appointments[j].checkappointmentDate, 'day')
			) {
				//
				appointmentsCount.push(this.state.appointments[j].checkappointmentDate);
			}
		}
		//
		//

		appointmentsCount = appointmentsCount.length;

		// moment.parseZone(new Date(item.checkappointmentDate))

		const { location } = this.props;

		return (
      <div>
        {!user.assistId ? (
          <div className='wrapper'>
            <aside className='main-sidebar'>
              <section className='sidebar'>
                <ul
                  style={
                    location.pathname ===
                      "/specialist/appointment-consultation/" +
                        this.props.match.params.appointmentId &&
                    localStorage.getItem("consultationOpenFrom") === "VideoCall"
                      ? { pointerEvents: "none" }
                      : null
                  }
                  className={
                    localStorage.getItem("consultationOpenFrom") ===
                      "VideoCall" &&
                    location.pathname ===
                      "/specialist/appointment-consultation/" +
                        this.props.match.params.appointmentId
                      ? "sidebar-menu  DisabledSidebar"
                      : "sidebar-menu"
                  }
                  data-widget='tree'
                >
                  <li
                    className={
                      location.pathname === "/specialist/my-profile"
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to='/specialist/my-profile'
                      onClick={
                        condition2
                          ? this.toggle.bind(this, "dont")
                          : this.toggle.bind(this, false)
                      }
                    >
                      <i className='fa '>
                        <SVGICONS.SpecialistProfileLeftSvg />
                      </i>{" "}
                      <span>Profile</span>
                    </Link>
                  </li>

                  <li
                    className={
                      location.pathname === "/specialist/my-documents" ||
                      location.pathname === "/specialist/upload-document"
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to={"/specialist/my-documents"}
                      onClick={
                        condition2
                          ? this.toggle.bind(this, "dont")
                          : this.toggle.bind(this, false)
                      }
                    >
                      <i className='fa '>
                        <SVGICONS.SpecialistMyDocumentSvg />
                      </i>{" "}
                      <span>My Documents</span>
                    </Link>
                  </li>

                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-calendar"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-calendar" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.MyAppointmentSvg />
                        </i>{" "}
                        <span>My Calendar</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-calendar" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.MyAppointmentSvg />
                        </i>{" "}
                        <span>My Calendar</span>
                      </Link>
                    </li>
                  )}
                  {user.isVerified == 2 ? (
                    <li
                      onClick={this.isClicked}
                      className={
                        location.pathname === "/specialist/my-appointment"
                          ? "active"
                          : ""
                      }
                    >
                      {condition ? (
                        <Link
                          to={{
                            pathname: condition
                              ? "/specialist/my-appointment"
                              : null,
                            state: 1,
                          }}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      ) : (
                        <Link
                          to={condition ? "/specialist/my-appointment" : null}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      )}
                    </li>
                  ) : (
                    <li onClick={this.isClicked} className='DisabledSidebar'>
                      {condition ? (
                        <Link
                          to={{
                            pathname: condition
                              ? "/specialist/my-appointment"
                              : null,
                            state: 1,
                          }}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      ) : (
                        <Link
                          to={condition ? "/specialist/my-appointment" : null}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      )}
                    </li>
                  )}

                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-patients"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-patients" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistMyPatientSvg />
                        </i>{" "}
                        <span>My Patients</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-patients" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistMyPatientSvg />
                        </i>{" "}
                        <span>My Patients</span>
                      </Link>
                    </li>
                  )}
                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/statistics"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/statistics" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistStatsSvg />
                        </i>{" "}
                        <span>Stats</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/statistics" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistStatsSvg />
                        </i>{" "}
                        <span>Stats</span>
                      </Link>
                    </li>
                  )}

                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-feedbacks"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-feedbacks" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistFeedbackSvg />
                        </i>{" "}
                        <span>My Feedbacks</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-feedbacks" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistFeedbackSvg />
                        </i>{" "}
                        <span>My Feedbacks</span>
                      </Link>
                    </li>
                  )}

                  <li
                    className={
                      location.pathname === "/specialist/my-accounts" ||
                      location.pathname ===
                        "/specialist/my-accounts/security" ||
                      location.pathname === "/specialist/my-accounts/payment"
                        ? "active set-img-ava"
                        : "set-img-ava"
                    }
                    onClick={this.isClicked}
                  >
                    <Link
                      to={{ pathname: "/specialist/my-accounts", state: 1 }}
                      onClick={
                        condition2
                          ? this.toggle.bind(this, "dont")
                          : this.toggle.bind(this, false)
                      }
                    >
                      <img src={require("../../images/accountb.png")} alt='' />
                      <span>My Account</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/specialist/my-settings" ||
                      location.pathname ===
                        "/specialist/my-settings/prescription" ||
                      location.pathname ===
                        "/specialist/my-settings/calendar" ||
                      location.pathname === "/specialist/my-settings/secretary"
                        ? "active"
                        : ""
                    }
                    onClick={this.isClicked}
                  >
                    <Link
                      to={{ pathname: "/specialist/my-settings", state: 1 }}
                      onClick={
                        condition2
                          ? this.toggle.bind(this, "dont")
                          : this.toggle.bind(this, false)
                      }
                    >
                      <i className='fa '>
                        <SVGICONS.SettingsSvg />
                      </i>{" "}
                      <span>Settings</span>
                    </Link>
                  </li>
                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-blog"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-blog" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.HealthTipSvg />
                        </i>{" "}
                        <span>Blog</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-blog" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.HealthTipSvg />
                        </i>{" "}
                        <span>Blog</span>
                      </Link>
                    </li>
                  )}
                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/notifications"
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={condition ? "/specialist/notifications" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.NotificationsSvg />
                        </i>{" "}
                        <span>Notifications</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/notifications" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.NotificationsSvg />
                        </i>{" "}
                        <span>Notifications</span>
                      </Link>
                    </li>
                  )}
                  {/* <li className={(location.pathname === '/specialist/support') ? 'active' : ''}><Link to={condition ? "/specialist/support" : null} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}><i className="fa ">
                                    <SVGICONS.NotificationsSvg />
                                </i> <span>Support</span></Link></li> */}
                </ul>
              </section>
            </aside>
            <div>
              <Switch>
                <Route
                  exact
                  path='/specialist/support'
                  component={specialistSupport}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist'
                  component={SpecialistProfile}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-profile'
                  component={SpecialistProfile}
                  // onEnter={isSpecialist}
                />
                {/* <Route exact
                path="/specialist/my-documents"
                component={Specialistdocument}
              // onEnter={isSpecialist}
              /> */}
                <Route
                  exact
                  path='/specialist/my-documents'
                  component={NewDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/upload-document'
                  component={specialistUploadDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/edit-document/:documentId'
                  component={specialistUploadDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-calendar'
                  component={specialistEvents}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-appointment'
                  component={specialistappointment}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/assistantList'
                  component={specialistAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/add-user'
                  component={specialistAddEditAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/edit-user/:userId'
                  component={specialistAddEditAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/appointment-consultation/:appointmentId'
                  component={appointmentConsultation}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/my-feedbacks'
                  component={feedbackListing}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-notifications'
                  component={notifications}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts'
                  component={specialistAccounts}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts/security'
                  component={specialistSecurity}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/account/upgrade_page'
                  component={upgrade}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts/payment'
                  component={specialistPayment}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings'
                  component={specialistSettings}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/prescription'
                  component={specialistPrescription}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/calendar'
                  component={specialistCalendar}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/secretary'
                  component={specialistSecretary}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/add-blog'
                  component={specialistBlog}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/edit-blog/:blogId'
                  component={specialistBlog}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-blog'
                  component={specialistBlogList}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-patients'
                  component={specialistPatients}
                  // onEnter={isSpecialist}
                />
                {/* <Route path="/specialist/video-call/:videoId" component={VideoCallReceive} onEnter={isSpecialist} /> */}
                <Route
                  path='/specialist/waiting-room-caller'
                  component={callWaiting}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/video-call-connect/:videoId'
                  component={videoCallConnect}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/video-call-receive/:videoId'
                  component={videoCallReceive}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/waiting-room-receiver/:videoId/:appointmentId'
                  component={watingRoomReceiver}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/statistics'
                  component={specialistStatistics}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/appointment-history/:patientId'
                  component={specialistAppointmentHistory}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/notifications'
                  component={notifications}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/blogdetails/:blogId'
                  component={blogDetails}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/verifySpecialist'
                  component={verifySpecialist}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/feedback-response/:appointmentId/:patientId'
                  component={feedbackResponse}
                  // onEnter={isSpecialist}
                />
              </Switch>
            </div>
          </div>
        ) : (
          <div className='wrapper'>
            <aside className='main-sidebar'>
              <section className='sidebar'>
                <ul className='sidebar-menu' data-widget='tree'>
                  {/* <li className={(location.pathname === '/specialist/my-profile') ? 'active' : ''}><Link to="/specialist/my-profile" onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistProfileLeftSvg />
		  </i> <span>Profile</span></Link></li> */}

                  {/* <li className={(location.pathname === '/specialist/my-documents' || location.pathname === '/specialist/upload-document') ? 'active' : ''} ><Link to={"/specialist/my-documents"}   onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistMyDocumentSvg />
		  </i> <span>My Documents</span></Link></li> */}

                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-calendar"
                          ? "active"
                          : null
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-calendar" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.MyAppointmentSvg />
                        </i>{" "}
                        <span>My Calendar</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-calendar" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.MyAppointmentSvg />
                        </i>{" "}
                        <span>My Calendar</span>
                      </Link>
                    </li>
                  )}
                  {user.isVerified == 2 ? (
                    <li
                      onClick={this.isClicked}
                      className={
                        location.pathname === "/specialist/my-appointment"
                          ? "active"
                          : null
                      }
                    >
                      {condition ? (
                        <Link
                          to={{
                            pathname: condition
                              ? "/specialist/my-appointment"
                              : null,
                            state: 1,
                          }}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {this.state.appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      ) : (
                        <Link
                          to={condition ? "/specialist/my-appointment" : null}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {this.state.appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      )}
                    </li>
                  ) : (
                    <li onClick={this.isClicked} className='DisabledSidebar'>
                      {condition ? (
                        <Link
                          to={{
                            pathname: condition
                              ? "/specialist/my-appointment"
                              : null,
                            state: 1,
                          }}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {this.state.appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      ) : (
                        <Link
                          to={condition ? "/specialist/my-appointment" : null}
                          onClick={
                            condition2
                              ? this.toggle.bind(this, "dont")
                              : this.toggle.bind(this, false)
                          }
                        >
                          <i className='fa '>
                            <SVGICONS.SpecialistMyAppointmentSvg />
                          </i>
                          <span>
                            My Appointments
                            <span className='appCount'>
                              {this.state.appointmentsCount}
                            </span>
                          </span>
                        </Link>
                      )}
                    </li>
                  )}

                  {user.isVerified == 2 ? (
                    <li
                      className={
                        location.pathname === "/specialist/my-patients"
                          ? "active"
                          : null
                      }
                    >
                      <Link
                        to={condition ? "/specialist/my-patients" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistMyPatientSvg />
                        </i>{" "}
                        <span>My Patients</span>
                      </Link>
                    </li>
                  ) : (
                    <li className='DisabledSidebar'>
                      <Link
                        to={condition ? "/specialist/my-patients" : null}
                        onClick={
                          condition2
                            ? this.toggle.bind(this, "dont")
                            : this.toggle.bind(this, false)
                        }
                      >
                        <i className='fa '>
                          <SVGICONS.SpecialistMyPatientSvg />
                        </i>{" "}
                        <span>My Patients</span>
                      </Link>
                    </li>
                  )}
                  {/* {	user.isVerified == 2 ?	<li className={(location.pathname === '/specialist/statistics') ? 'active' : ''}><Link to={condition ? "/specialist/statistics" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistStatsSvg />
						</i> <span>Stats</span></Link></li>
					:	<li className='DisabledSidebar'><Link to={condition ? "/specialist/statistics" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistStatsSvg />
						</i> <span>Stats</span></Link></li>
				} */}

                  {/* {user.isVerified == 2 ?	<li className={(location.pathname === '/specialist/my-feedbacks') ? 'active' : ''}><Link to={condition ? "/specialist/my-feedbacks" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistFeedbackSvg />
						</i> <span>My Feedbacks</span></Link></li>

					:								<li className='DisabledSidebar'><Link to={condition ? "/specialist/my-feedbacks" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.SpecialistFeedbackSvg />
						</i> <span>My Feedbacks</span></Link></li>
					} */}

                  <li
                    className={
                      location.pathname === "/specialist/my-settings"
                        ? "active"
                        : null
                    }
                    onClick={this.isClicked}
                  >
                    <Link
                      to={{ pathname: "/specialist/my-settings", state: 1 }}
                      onClick={
                        condition2
                          ? this.toggle.bind(this, "dont")
                          : this.toggle.bind(this, false)
                      }
                    >
                      <i className='fa '>
                        <SVGICONS.SettingsSvg />
                      </i>{" "}
                      <span>Settings</span>
                    </Link>
                  </li>
                  {/* {user.isVerified  == 2 ?	<li className={(location.pathname === '/specialist/my-blog') ? 'active' : ''}><Link to={condition ? "/specialist/my-blog" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.HealthTipSvg />
						</i> <span>Blog</span></Link></li>
					:
						<li className='DisabledSidebar'><Link to={condition ? "/specialist/my-blog" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.HealthTipSvg />
						</i> <span>Blog</span></Link></li>
					} */}

                  {/* {user.isVerified  == 2 ?	<li className={(location.pathname === '/specialist/assistantList') ? 'active' : ''}><Link to={condition ? "/specialist/assistantList" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.HealthTipSvg />
						</i> <span>Assistant</span></Link></li>
					:
						<li className='DisabledSidebar'><Link to={condition ? "/specialist/assistantList" : null} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }><i className="fa ">
							<SVGICONS.HealthTipSvg />
						</i> <span>Assistant</span></Link></li>
					} */}
                </ul>
              </section>
            </aside>
            <div>
              <Switch>
                <Route
                  exact
                  path='/specialist'
                  component={SpecialistProfile}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-profile'
                  component={SpecialistProfile}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-documents'
                  component={Specialistdocument}
                // onEnter={isSpecialist}
                /> */}
                <Route
                  exact
                  path='/specialist/my-documents'
                  component={NewDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/upload-document'
                  component={specialistUploadDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/edit-document/:documentId'
                  component={specialistUploadDocument}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-calendar'
                  component={specialistEvents}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-appointment'
                  component={specialistappointment}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/assistantList'
                  component={specialistAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/add-user'
                  component={specialistAddEditAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/edit-user/:userId'
                  component={specialistAddEditAssistant}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/appointment-consultation/:appointmentId'
                  component={appointmentConsultation}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/my-feedbacks'
                  component={feedbackListing}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-notifications'
                  component={notifications}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts'
                  component={specialistAccounts}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts/security'
                  component={specialistSecurity}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-accounts/payment'
                  component={specialistPayment}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings'
                  component={specialistSettings}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/prescription'
                  component={specialistPrescription}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/calendar'
                  component={specialistCalendar}
                  // onEnter={isSpecialist}
                />
                <Route
                  exact
                  path='/specialist/my-settings/secretary'
                  component={specialistSecretary}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/add-blog'
                  component={specialistBlog}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/edit-blog/:blogId'
                  component={specialistBlog}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-blog'
                  component={specialistBlogList}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/my-patients'
                  component={specialistPatients}
                  // onEnter={isSpecialist}
                />
                {/* <Route path="/specialist/video-call/:videoId" component={VideoCallReceive} onEnter={isSpecialist} /> */}
                <Route
                  path='/specialist/waiting-room-caller'
                  component={callWaiting}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/video-call-connect/:videoId'
                  component={videoCallConnect}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/video-call-receive/:videoId'
                  component={videoCallReceive}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/waiting-room-receiver/:videoId/:appointmentId'
                  component={watingRoomReceiver}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/statistics'
                  component={specialistStatistics}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/appointment-history/:patientId'
                  component={specialistAppointmentHistory}
                  // onEnter={isSpecialist}
                />
                <Route
                  path='/specialist/notifications'
                  component={notifications}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='specialist/blogdetails/:blogId'
                  component={blogDetails}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/verifySpecialist'
                  component={verifySpecialist}
                  // onEnter={isSpecialist}
                />

                <Route
                  path='/specialist/feedback-response/:appointmentId/:patientId'
                  component={feedbackResponse}
                  // onEnter={isSpecialist}
                />
              </Switch>
            </div>
          </div>
        )}
        <SpecialistPopup
          open={this.state.modalSpecialist}
          onClose={() =>
            this.setState({ modalSpecialist: !this.state.modalSpecialist })
          }
          handleSubmit={this.handleSubmit.bind(this)}
        />
      </div>
    );
	}
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		crumbs: state.dashboards,
		appointments: state.dashboard.appointmentsCount,
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(dashboardActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
